import { Injectable } from '@angular/core';
import { CategorieAuditBpf } from 'src/app/models/bpf/bpf-audit.model';

/**
 * Conserve les filtres de l'écran BPF (entité/période + catégories et motif d'audit cochés) le
 * temps de la session (pas persisté au rechargement de page) — permet de revenir sur l'écran BPF
 * depuis une fiche session/participant/formateur sans perdre la sélection. Le résumé et l'audit
 * global eux-mêmes ne sont volontairement pas conservés : ils sont rechargés en direct au retour
 * (voir ExportBpfComponent.chargerResumeEtAudit), pour refléter une éventuelle correction faite
 * entre-temps plutôt qu'un instantané d'avant cette correction.
 */
@Injectable({
  providedIn: 'root',
})
export class BpfEcranStateService {
  public idsEntiteSelectionnees: number[] | null = null;
  public anneeSelectionnee: number | null = null;
  public dateDebut: Date | null = null;
  public dateFin: Date | null = null;
  public categoriesSelectionnees: Set<CategorieAuditBpf> | null = null;
  public motifSelectionne: string | null = null;
  public gestionnaireSelectionne: number | null = null;
  public motifsDeplies = false;
  public nombreResultatsAffiches: number | null = null;

  public aUnEtatSauvegarde(): boolean {
    return this.idsEntiteSelectionnees !== null;
  }

  public sauvegarder(etat: {
    idsEntiteSelectionnees: number[];
    anneeSelectionnee: number;
    dateDebut: Date;
    dateFin: Date;
    categoriesSelectionnees: Set<CategorieAuditBpf>;
    motifSelectionne: string | null;
    gestionnaireSelectionne: number | null;
    motifsDeplies: boolean;
    nombreResultatsAffiches: number;
  }): void {
    this.idsEntiteSelectionnees = [...etat.idsEntiteSelectionnees];
    this.anneeSelectionnee = etat.anneeSelectionnee;
    this.dateDebut = etat.dateDebut;
    this.dateFin = etat.dateFin;
    this.categoriesSelectionnees = new Set(etat.categoriesSelectionnees);
    this.motifSelectionne = etat.motifSelectionne;
    this.gestionnaireSelectionne = etat.gestionnaireSelectionne;
    this.motifsDeplies = etat.motifsDeplies;
    this.nombreResultatsAffiches = etat.nombreResultatsAffiches;
  }
}
